module.exports = __webpack_public_path__ + "static/img/login-samu-02.2efd2f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-samu-02.png
// module id = AuzY
// module chunks = 4